<template>
  <div class="Div">
    <!-- 第一屏 -->
    <div
      class="InitialScreen"
      :style="'height:'+height+''"
    >
      <img
        class="OneBackImg"
        :src="ScreenImg"
        alt=""
      >
      <div class="sb">
        <img
          class="sbImg"
          src="../../../static/image/shubiao.png"
          alt=""
          srcset=""
        >
        <span class="sp1"></span>
        <span class="span"></span>
      </div>
    </div>
    <!-- 通知信息 -->
    <section class="section1">
      <div class="stitle">
        <p class="p">{{newsList.classInfo.type_name_cn}}</p>
        <p class="p">{{newsList.classInfo.type_name_en}}</p>
        <img
          src="../../../static/image/zhuangshi.png"
          alt=""
        >
      </div>
      <ul class="news SecNews" v-if="newsList.list.length>0">
        <li
          class="li"
          v-for="(item,i) of newsList.list"
          :key="i"
          @click="detailsClick(item,25)"
        >
          <img
            class="newImg"
            :src="item.article_img"
            alt=""
          >
          <div
            class="ellipsis4 headline"
            :title="item.article_title_cn"
          >
            {{item.article_title_cn}}

          </div>
        </li>
      </ul>
      <el-button
        class="more"
        @click="moreNews(newsList.classInfo.article_type_id,25)"
      >{{newsList.seeMore}}</el-button>
    </section>
    <!-- 膳食公示 -->
    <section class="section2">
      <div class="stitle">
        <p class="p">{{lists1.classInfo.type_name_cn}}</p>
        <p class="p">{{lists1.classInfo.type_name_en}}</p>
        <img
          src="../../../static/image/zhuangshi.png"
          alt=""
        >
      </div>
      <div class="content" v-if="lists1.list.length>0">
        <swiper
          ref="mySwiper"
          :options="swiperOption"
          class="myswiper"
        >
          <swiper-slide
            class="swiperslide"
            v-for="(item,i) of lists1.list"
            :key="i"
          >
            <!-- @click="detailsClick(item)" -->
            <div
              class="swiperDiv"
              @mouseenter="onEnter"
              @mouseleave="onLeave"
            >
              <img
                class="foodImg"
                :src="item.article_img"
                alt=""
                :data-pages='i'
              >
            </div>
          </swiper-slide>
        </swiper>
        <!-- <div class="swiper-button-prev"><img
            src="../../../static/image/left.png"
            alt=""
            srcset=""
          ></div> -->
        <!--左箭头。如果放置在swiper-container外面，需要自定义样式。-->
        <!-- <div class="swiper-button-next"><img
            src="../../../static/image/right.png"
            alt=""
            srcset=""
          ></div> -->
        <!--右箭头。如果放置在swiper-container外面，需要自定义样式。-->
      </div>
      <el-button
        class="more"
        @click="moreService(lists1.classInfo.article_type_id,15)"
      >{{lists1.seeMore}}</el-button>
    </section>
    <!-- 卫生保健 -->
    <section class="section3">
      <div class="stitle">
        <p class="p">{{lists2.classInfo.type_name_cn}}</p>
        <p class="p">{{lists2.classInfo.type_name_en}}</p>
        <img
          src="../../../static/image/zhuangshi.png"
          alt=""
        >
      </div>
      <div class="content" v-if="lists2.list.length>0">
        <div class="left">
          <div
            v-for="(item,i) of lists2.list.slice(0,3)"
            :key="i"
            class="text"
            @click="detailsClick(item,16)"
          >
            <p
              class="title ellipsis2"
              :title="item.article_title_cn"
            >
              {{item.article_title_cn}}
            </p>
            <p class="time">

              {{item.send_time}}
            </p>
          </div>
        </div>
        <div class="middle">
          <img
            class="img"
            :src="lists2.banner"
            alt=""
          >
        </div>
        <div
          class="right"
          v-if="lists2.list.length>3"
        >
          <div
            v-for="(item,i) of lists2.list.slice(3)"
            :key="i"
            class="text"
            @click="detailsClick(item,16)"
          >
            <p
              class="title ellipsis2"
              :title="item.article_title_cn"
            >
              {{item.article_title_cn}}
            </p>
            <p class="time">
              {{item.send_time}}
            </p>
          </div>
        </div>
      </div>
      <el-button
        class="more"
        @click="moreService(lists2.classInfo.article_type_id,16)"
      >{{lists2.seeMore}}</el-button>
    </section>
    <!-- 交通服务 -->
    <section class="section4">
      <div class="stitle">
        <p class="p">{{lists3.classInfo.type_name_cn}}</p>
        <p class="p">{{lists3.classInfo.type_name_en}}</p>
        <img
          src="../../../static/image/zhuangshi.png"
          alt=""
        >
      </div>
      <div class="content" v-if="lists3.list.length>0">
        <img
          class="img"
          :src="lists3.banner"
          alt=""
        >
        <div class="right">
          <div
            v-for="(item,i) of lists3.list"
            :key="i"
            @click="detailsClick(item,14)"
            class="text"
          >
            <p
              class="title ellipsis"
              :title="item.article_title_cn"
            >
              {{item.article_title_cn}}
            </p>
            <p class="time">
              {{item.send_time}}
            </p>
          </div>
        </div>
      </div>
      <el-button
        class="more"
        @click="moreService(lists3.classInfo.article_type_id,14)"
      >{{lists3.seeMore}}</el-button>
    </section>
    <!-- 周末托管 -->
    <section class="section5">
      <!-- :style="'background: url('+lists4.background_img+') no-repeat center;background-size: cover;'" -->
      <img
        class="backImg"
        :src="lists4.background_img"
        alt=""
      >
      <div class="stitle">
        <p class="p">{{lists4.classInfo.type_name_cn}}</p>
        <p class="p">{{lists4.classInfo.type_name_en}}</p>
        <img
          src="../../../static/image/zhuangshi2.png"
          alt=""
        >
      </div>
      <div class="content" v-if="lists4.data.length>0">
        <div class="divImg">
          <img
            :src="lists4.data[0].article_img"
            alt=""
            srcset=""
            class="img"
          >

        </div>
        <div class="infor">
          <div
            class="div ellipsis"
            v-for="(item,i) of lists4.data"
            :key="i"
            :title="item.article_title_cn"
            @click="detailsClick(item,26)"
          >
            {{item.article_title_cn}}
          </div>
          <el-button
            class="more"
            @click="moreService(lists4.classInfo.article_type_id,26)"
          >{{lists4.seeMore}}</el-button>
        </div>
      </div>
    </section>
    <!-- 安全教育 -->
    <section class="section6">
      <div class="stitle">
        <p class="p">{{lists5.classInfo.type_name_cn}}</p>
        <p class="p">{{lists5.classInfo.type_name_en}}</p>
        <img
          src="../../../static/image/zhuangshi.png"
          alt=""
        >
      </div>
      <div class="content" v-if="lists5.list.length>0">
        <ul>
          <li
            class="li"
            v-for="(item,i) of lists5.list"
            :key="i"
            @click="detailsClick(item,27)"
          >
            <div class="divimg">
              <img
                class="img"
                :src="item.article_img"
                alt=""
              >

            </div>
            <p
              class="title ellipsis2"
              :title="item.article_title_cn"
            >{{item.article_title_cn}}</p>
            <p class="time">{{item.send_time}}</p>
          </li>
        </ul>
      </div>
      <el-button
        class="more"
        @click="moreService(lists5.classInfo.article_type_id,27)"
      >{{lists5.seeMore}}</el-button>
    </section>
    <!-- 服务指南 -->
    <section class="section7">
      <div class="stitle">
        <p class="p">{{lists6.classInfo.type_name_cn}}</p>
        <p class="p">{{lists6.classInfo.type_name_en}}</p>
        <img
          src="../../../static/image/zhuangshi.png"
          alt=""
        >
      </div>
      <div class="content" v-if="lists6.list.length>0">

        <div class="right">
          <div
            v-for="(item,i) of lists6.list"
            :key="i"
            @click="detailsClick(item,28)"
            class="text"
          >
            <p
              class="title ellipsis"
              :title="item.article_title_cn"
            >{{item.article_title_cn}}</p>
            <p class="time">{{item.send_time}}</p>
          </div>
        </div>
        <img
          class="img"
          :src="lists6.banner"
          alt=""
        >
      </div>
      <el-button
        class="more"
        @click="moreService(lists6.classInfo.article_type_id,28)"
      >{{lists6.seeMore}}</el-button>
    </section>
  </div>
</template>
<script>
import { mapState, mapGetters, mapActions, mapMutations } from "vuex";
import { Swiper, SwiperSlide, directive } from "vue-awesome-swiper";
import "swiper/css/swiper.css";
import {
  notificationInformation,
  dietPublicity,
  healthCare,
  transportServices,
  weekendHosting,
  safetyEducation,
  serviceInformation
} from "../../api/Article";
import { getBanner } from "../../api/home";
export default {
  name: "SchoolService",
  data() {
    let _this = this;
    return {
      ScreenImg: "",
      height: "", //高度
      newsList: { list: {}, classInfo: {} }, //头条新闻
      swiperOption: {
        pagination: {
          el: ".swiper-pagination",
          clickable: true
        },
        initialSlide: 0,
        autoplay: {
          delay: 3000,
          stopOnLastSlide: false,
          disableOnInteraction: false
        },
        centeredSlides: true,
        // centeredSlidesBounds: true,
        effect: "coverflow",
        // grabCursor: true,
        slidesPerView: 2,
        // centeredSlides:true,
        // spaceBetween: 0,
        coverflowEffect: {
          rotate: 0,
          stretch: 120,
          depth: 150,
          modifier: 2,
          slideShadows: false
        },
        // setWrapperSize: true,
        preventClicksPropagation: true,
        loop: true,
        loopAdditionalSlides: 10,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        },
        // observer: true,
        // observeParents: true,
        on: {
          click: function(event) {
            // console.log(
            //   "你点了Swiper",
            //   this.realIndex,
            //   _this.lists1.list[this.realIndex]
            // );
            var index = event.target.getAttribute('data-pages');
            var laber = [0, 6, 15, 18];
            var laPath = ["/", "/SchoolService", "/SchoolService"];
            //
            var routeData = _this.$router.resolve({
              path: "/NewsDetails",
              query: {
                laber: JSON.stringify(laber),
                id: _this.lists1.list[index].article_id,
                laPath: JSON.stringify(laPath)
              }
            });
            window.open(routeData.href, "_blank");
          }
        }
      }, //swiper参数
      warmNum: 0,
      warmHeight: 559,
      lists1: { list: [{}], classInfo: {} }, //膳食公示
      lists2: { list: [{}, {}], classInfo: {} }, //卫生保健
      lists3: { list: [{}, {}], classInfo: {} }, //交通服务
      lists4: { data: [{}, {}], classInfo: {} }, //周末托管
      lists5: { list: [{}, {}], classInfo: {} }, //安全教育
      lists6: { list: [{}, {}], classInfo: {} } //服务指南
    };
  },
  components: {
    Swiper,
    SwiperSlide
  },
  directives: {
    swiper: directive
  },
  computed: {
    ...mapState("user", ["headerHeight"]),
    swiper() {
      return this.$refs.mySwiper.$swiper;
    }
  },
  methods: {
    // 监听浏览器高度宽度变化
    getHeight() {
      //   console.log(this.headerHeight, "dfsf");
      this.height = window.innerHeight - this.headerHeight + "px";
    },
    // 学术校园
    swiperClick(i) {
      // console.log(i);
    },
    // 鼠标移入暂停循环轮播
    onEnter() {
      this.swiper.autoplay.stop();
    },
    onLeave() {
      if (this.swiper.autoplay) {
        this.swiper.autoplay.start();
      }
    },
    // 温馨校园
    warmClick(item) {
      this.warmNum = item;
    },
    // 服务列表页
    moreService(index, i) {
      // ServiceList
      var laber = [0, 6, i, 17];
      var laPath = ["/", "/SchoolService", "/SchoolService"];
      this.$router.push({
        path: "/ServiceList",
        query: {
          laber: JSON.stringify(laber),
          uid: index,
          laPath: JSON.stringify(laPath)
        }
      });
    },
    //详情页
    detailsClick(item, x) {
      // this.swiper.autoplay.stop();
      // this.swiper.autoplay.start();
      // this.swiper.update();
      var laber = [0, 6, x, 18];
      var laPath = ["/", "/SchoolService", "/SchoolService"];
      //
      var routeData = this.$router.resolve({
        path: "/NewsDetails",
        query: {
          laber: JSON.stringify(laber),
          id: item.article_id,
          laPath: JSON.stringify(laPath)
        }
      });
      window.open(routeData.href, "_blank");
    },
    // 跳转新闻列表
    moreNews(index, i) {
      var laber = [0, 6, i, 17];
      var laPath = ["/", "/SchoolService", "/SchoolService"];
      this.$router.push({
        path: "/NewsList",
        query: {
          laber: JSON.stringify(laber),
          laPath: JSON.stringify(laPath),
          uid: index
        }
      });
    }
  },
  created() {
    // setTimeout(() => {
    //   this.swiperOption.autoplay.delay = 3000;
    // }, 500);
    // 第一屏banner
    getBanner({
      address: 10
    }).then(res => {
      this.ScreenImg = res.data.banner_img;
    });
  },
  mounted() {
    window.addEventListener("resize", this.getHeight);
    this.getHeight();
    // 通知信息
    notificationInformation({
      limit: 6
    }).then(res => {
      // console.log(res.data)
      this.newsList = res.data;
    });
    // 膳食公示
    dietPublicity({
      limit: 5
    }).then(res => {
      // console.log(res.data);
      this.lists1 = res.data;
      this.swiper.slideNext();
    });
    // 卫生保健
    healthCare({
      limit: 6
    }).then(res => {
      // console.log(res.data);
      this.lists2 = res.data;
    });
    // 交通服务
    transportServices({
      limit: 4
    }).then(res => {
      // console.log(res.data);
      this.lists3 = res.data;
    });
    // 周末托管
    weekendHosting({
      limit: 3
    }).then(res => {
      // console.log(res.data);
      this.lists4 = res.data;
    });
    // 安全教育
    safetyEducation({
      limit: 3
    }).then(res => {
      // console.log(res.data);
      this.lists5 = res.data;
    });
    // 服务指南
    serviceInformation({
      limit: 4
    }).then(res => {
      // console.log(res.data);
      this.lists6 = res.data;
    });

  },
  destroyed() {
    window.removeEventListener("resize", this.getHeight);
  }
};
</script>
<style lang="scss" scoped>
@import "../../assets/custom/common.scss";
.InitialScreen {
  position: relative;
  width: 100%;
  //   height: 79.5vh;
  background-size: cover;
  padding-top: 0.1px;
  &::before {
    display: block;
    position: absolute;
    content: "";
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.3);
    z-index: 1;
    top: 0;
    left: 0;
  }
  .overview {
    position: relative;
    margin-left: 16.1%;
    margin-top: 5%;
    z-index: 1;
    text-align: left;
    .title {
      position: relative;
      font-size: px2Rem(80px);
      //   font-family: "STXinwei";
      font-weight: 400;
      color: rgba(255, 255, 255, 1);
      cursor: pointer;
      span {
        vertical-align: middle;
      }
      &::before {
        display: block;
        position: absolute;
        content: "";
        width: px2Rem(100px);
        height: px2Rem(4px);
        bottom: px2Rem(-30px);
        left: px2Rem(10px);
        border-radius: 2px;
        background-color: #fff;
      }
    }
    .overImg {
      width: px2Rem(38px);
      height: px2Rem(38px);
      margin-left: px2Rem(15px);
    }
    .caption {
      width: px2Rem(707px);
      margin-top: px2Rem(70px);
      font-size: px2Rem(28px);
      //   font-family: STXinwei;
      font-weight: 400;
      color: rgba(255, 255, 255, 1);
      line-height: px2Rem(35px);
    }
    .btn {
      padding: px2Rem(19px) px2Rem(68px);
      margin-top: px2Rem(60px);
      border: 2px solid rgba(255, 255, 255, 1);
      border-radius: 4px;
      font-size: px2Rem(24px);
      //   font-family: STXinwei;
      font-weight: 400;
      color: rgba(255, 255, 255, 1);
      background: rgba(0, 0, 0, 0);
      transition: 0.3s;
      &:hover {
        background: rgba(255, 255, 255, 0.3);
      }
    }
  }
}
.section1 {
  width: px2Rem(1300px);
  margin: auto;
  padding-bottom: px2Rem(70px);
  // .more:hover{
  //   background: #ecf5ff;
  // }
}
.section2 {
  padding-bottom: px2Rem(74px);
  background: #f5f5f5;
  .content {
    position: relative;
    width: px2Rem(1300px);
    // height: px2Rem(500px);
    padding-bottom: px2Rem(40px);
    margin: px2Rem(35px) auto px2Rem(0px);
    --swiper-theme-color: #e2bb81;
    .swiper-button-next,
    .swiper-button-prev {
      width: px2Rem(54px);
      height: px2Rem(54px);
      top: 42%;
      // left: ;
      outline: none;
      &::after {
        display: none;
      }
      border-radius: 51%;
      transition: 0.5s;
      &:hover {
        background: rgba(28, 50, 120, 0.1);
      }
      img {
        width: px2Rem(54px);
        height: px2Rem(54px);
      }
    }
    .foodImg {
      width: px2Rem(600px);
      height: px2Rem(370px);
    }
    .myswiper {
      width: px2Rem(1080px);
      margin: auto;
    }
    .swiperDiv {
      cursor: pointer;
    }
  }
}
.section3 {
  padding-bottom: px2Rem(60px);
  .content {
    width: px2Rem(1300px);
    // height: px2Rem(500px);
    padding-bottom: px2Rem(40px);
    margin: px2Rem(20px) auto 0;
    font-size: 0;
    > div {
      display: inline-block;
      cursor: pointer;
    }
    .left {
      width: px2Rem(333px);
      margin-right: px2Rem(15px);
      vertical-align: top;
    }
    .middle {
      // padding-top: px2Rem(15px);
      vertical-align: top;
    }
    .right {
      width: px2Rem(333px);
      margin-left: px2Rem(15px);
      vertical-align: top;
    }
    .text {
      padding: px2Rem(15px) 0 px2Rem(15px);
      border-bottom: 1px dashed rgba(205, 205, 205, 1);
    }
    .title {
      height: px2Rem(58px);
      margin-bottom: px2Rem(15px);
      font-size: px2Rem(28px);
      font-weight: 400;
      color: rgba(51, 51, 51, 1);
      &:hover {
        color: #1c3278;
      }
    }
    .time {
      font-size: px2Rem(20px);
      font-weight: 400;
      color: rgba(153, 153, 153, 1);
    }
  }
  .img {
    width: px2Rem(600px);
    height: px2Rem(365px);
    padding-top: px2Rem(15px);
  }
}
.section4 {
  padding-bottom: px2Rem(60px);
  background: #f5f5f5;
  .content {
    width: px2Rem(1300px);
    padding-bottom: px2Rem(40px);
    margin: px2Rem(30px) auto 0;
    font-size: 0;
    img {
      display: inline-block;
      width: px2Rem(650px);
      height: px2Rem(375px);
      margin-right: px2Rem(20px);
      padding-top: px2Rem(25px);
    }
    .right {
      display: inline-block;
      width: px2Rem(629px);
      vertical-align: top;
      cursor: pointer;
      .text {
        padding: px2Rem(25px) 0 px2Rem(15px);
        border-bottom: 1px dashed rgba(205, 205, 205, 1);
      }
      .title {
        height: px2Rem(28px);
        margin-bottom: px2Rem(10px);
        font-size: px2Rem(28px);
        font-weight: 400;
        color: rgba(51, 51, 51, 1);
        &:hover {
          color: #1c3278;
        }
      }
      .time {
        font-size: px2Rem(20px);
        font-weight: 400;
        color: rgba(153, 153, 153, 1);
      }
    }
  }
}
.section5 {
  position: relative;
  height: px2Rem(840px);
  padding-bottom: px2Rem(50px);
  &::before {
    display: block;
    position: absolute;
    content: "";
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 0;
    top: 0;
    left: 0;
  }
  .backImg {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    z-index: -1;
  }
  .stitle {
    position: relative;
    p {
      color: rgba(255, 255, 255, 1);
      &:nth-of-type(2) {
        color: rgba(255, 255, 255, 1);
      }
    }
  }
  .content {
    position: relative;
    width: px2Rem(1300px);
    padding-bottom: px2Rem(40px);
    margin: px2Rem(30px) auto 0;
    font-size: 0;
    .divImg {
      width: px2Rem(709px);
      height: px2Rem(473px);
      overflow: hidden;
      &:hover {
        .img {
          transform: scale(1.1);
        }
      }
    }
    .img {
      width: 100%;
      height: 100%;
      transition: 0.3s;
    }
    .infor {
      position: absolute;
      width: px2Rem(600px);
      right: px2Rem(0px);
      top: px2Rem(45px);
      padding: px2Rem(45px) px2Rem(20px) px2Rem(30px);
      background: rgba(255, 255, 255, 1);
      border-radius: 8px;
      font-size: px2Rem(30px);
      font-weight: 400;

      .more {
        margin-top: px2Rem(40px);
      }
      .div {
        position: relative;
        cursor: pointer;
        transition: 0.3s;
        left: 0px;
        color: #333;
        &:nth-of-type(2) {
          margin: px2Rem(50px) 0;
        }
        &:hover {
          left: 10px;
          color: rgba(28, 50, 120, 1);
        }
      }
    }
  }
}
.section6 {
  padding-bottom: px2Rem(60px);
  background: #f5f5f5;
  .content {
    width: px2Rem(1300px);
    padding-bottom: px2Rem(40px);
    margin: px2Rem(30px) auto 0;
    font-size: 0;
    .li {
      display: inline-block;
      width: px2Rem(400px);
      margin-right: px2Rem(40px);
      font-size: 0;
      cursor: pointer;

      &:hover {
        .img {
          transform: scale(1.1);
        }
        .title {
          color: #1c3278;
        }
      }
      &:nth-of-type(3n) {
        margin-right: px2Rem(0px);
      }
      .divimg {
        overflow: hidden;
      }
      .img {
        display: inline-block;
        width: 100%;
        height: px2Rem(246px);
        transition: 0.5s;
      }
      .title {
        height: px2Rem(56px);
        margin: px2Rem(10px) 0;
        font-size: px2Rem(28px);
        font-weight: 400;
        color: rgba(51, 51, 51, 1);
        line-height: px2Rem(30px);
      }
      .time {
        font-size: px2Rem(20px);
        font-weight: 400;
        color: rgba(153, 153, 153, 1);
      }
    }
  }
}
.section7 {
  padding-bottom: px2Rem(60px);
  // background: #f5f5f5;
  .content {
    width: px2Rem(1300px);
    padding-bottom: px2Rem(40px);
    margin: px2Rem(30px) auto 0;
    font-size: 0;
    img {
      display: inline-block;
      width: px2Rem(650px);
      height: px2Rem(375px);
      margin-left: px2Rem(20px);
      padding-top: px2Rem(25px);
    }
    .right {
      display: inline-block;
      width: px2Rem(629px);
      vertical-align: top;
      cursor: pointer;
      .text {
        padding: px2Rem(25px) 0 px2Rem(15px);
        border-bottom: 1px dashed rgba(205, 205, 205, 1);
        &:hover {
          .title {
            color: #1c3278;
          }
        }
      }
      .title {
        height: px2Rem(28px);
        margin-bottom: px2Rem(10px);
        font-size: px2Rem(28px);
        font-weight: 400;
        color: rgba(51, 51, 51, 1);
      }
      .time {
        font-size: px2Rem(20px);
        font-weight: 400;
        color: rgba(153, 153, 153, 1);
      }
    }
  }
}
.title {
  z-index: 1;
}
.stitle {
  padding-top: px2Rem(60px);
}
.Div {
  font-family: "STXinwei";
  button {
    font-family: "STXinwei";
  }
}
.more {
  display: block;
  margin: px2Rem(10px) auto 0px;
  padding: px2Rem(20px) px2Rem(68);
  border: 1px solid rgba(28, 50, 120, 1);
  border-radius: 4px;
  font-size: px2Rem(24px);
  // font-family: STXinwei;
  background: rgba(0, 0, 0, 0);
  font-weight: 400;
  color: rgba(28, 50, 120, 1);
  transition: 0.3s;
  &:hover {
    background: rgba(28, 50, 120, 0.5);
    color: #fff;
    border: 1px solid #fff;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/SchoolService/Index.vue